import { observer } from 'mobx-react';
import * as React from 'react';

import './list.scss';

export type ListType =
    | 'listc_checkmark'
    | 'listc_module'
    | 'listc_free_module'
    | 'listc_discount_module';

interface ListProps {
    children: React.ReactNode;
    type: ListType;
    className?: string;
}

export const List = observer(function List(props: ListProps) {
    const { children, type = 'listc_checkmark' } = props;

    return (
        <ul className={classnames(props.className, 'listc', `listc--${type}`)}>
            {children}
        </ul>
    );
});
